import { render, staticRenderFns } from "./SettingsServices.vue?vue&type=template&id=5243a842&scoped=true&"
import script from "./SettingsServices.vue?vue&type=script&lang=js&"
export * from "./SettingsServices.vue?vue&type=script&lang=js&"
import style0 from "./SettingsServices.vue?vue&type=style&index=0&id=5243a842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243a842",
  null
  
)

export default component.exports